import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select, TextInput } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { TOrderFormValues } from '../../OrderForm.types';

export const OrderFormShippingSection: React.FC = () => {
  const localize = useLocalize();
  const { control } = useFormContext<TOrderFormValues>();

  const deliveryOptions = React.useMemo(
    () => [
      {
        id: 'inpost',
        label: localize('checkout.delivery.inpost.name') as string,
      },
    ],
    [localize]
  );

  return (
    <section className="admin-orders-detail__section">
      <h3 className="h6 admin-orders-detail__section-title">
        {localize('admin.orders.detail.section.shipping')}
      </h3>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="shippingData.firstName"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.firstname') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="shippingData.lastName"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.lastname') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
      </div>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="shippingData.email"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={localize('admin.orders.detail.shipping.email') as string}
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="shippingData.phone"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={localize('admin.orders.detail.shipping.phone') as string}
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
      </div>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="shippingData.street"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.street') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="shippingData.buildingNumber"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.building') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
      </div>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="shippingData.apartamentNumber"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.apartment') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="shippingData.city"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={localize('admin.orders.detail.shipping.city') as string}
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
      </div>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="shippingData.postalCode"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.postal') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="shippingData.deliveryMethod"
            control={control}
            render={({ field, fieldState }) => (
              <Select
                label={
                  localize('admin.orders.detail.shipping.delivery') as string
                }
                value={field.value}
                onChange={field.onChange}
                options={deliveryOptions}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                required
              />
            )}
          />
        </div>
      </div>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="shippingData.parcelLockerCode"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                label={
                  localize('admin.orders.detail.shipping.parcel') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="shippingData.additionalInfo"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                multiline
                minRows={2}
                label={
                  localize('admin.orders.detail.shipping.additional') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
      </div>
    </section>
  );
};
